import { getComponentFromName } from '@folklore/utils';
import classNames from 'classnames';

import * as AnimationComponents from '../../animations';
import Image from '../partials/Image';
import DocumentSubtitle from '../typography/DocumentSubtitle';
import DocumentTitle from '../typography/DocumentTitle';

import styles from '../../styles/headers/page-header.module.css';

interface PageHeaderProps {
    title: string;
    subtitle?: string;
    brand?: Brand;
    image?: Image;
    placeholder?: boolean;
    animation?: string;
    withoutImage?: boolean;
    className?: string;
}

function PageHeader({
    title,
    subtitle = null,
    brand = null,
    image = null,
    placeholder = false,
    animation = null,
    withoutImage = false,
    className = null,
}: PageHeaderProps) {
    const { handle: brandHandle } = brand || {};

    const AnimationComponent = getComponentFromName(AnimationComponents, animation, null);
    const withAfter = subtitle !== null || placeholder;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles[brandHandle]]: brandHandle !== null,
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                {AnimationComponent !== null ? <AnimationComponent /> : null}

                {!withoutImage && AnimationComponent === null ? (
                    <div className={styles.imageContainer}>
                        <Image
                            className={styles.image}
                            pictureClassName={styles.picture}
                            media={image}
                            size="responsive"
                            withoutSize
                            withPlaceholder
                        />
                    </div>
                ) : null}

                <div className={classNames([styles.content])}>
                    <DocumentTitle
                        className={styles.title}
                        html={title}
                        placeholder={placeholder}
                    />
                    {withAfter ? (
                        <div className={styles.after}>
                            {subtitle !== null || placeholder ? (
                                <DocumentSubtitle
                                    className={styles.subtitle}
                                    placeholder={placeholder}
                                >
                                    {subtitle}
                                </DocumentSubtitle>
                            ) : null}
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
}

export default PageHeader;
